// extracted by mini-css-extract-plugin
module.exports = {"reasons":"whatIs-module--reasons--hbagT"};